import React from "react";
import { BUSINESSES } from "@/data/gameData";
import { Lock } from "lucide-react";

const BusinessShowcase = () => (
  <section className="bg-white/70 border-y-4 border-slate-100 py-12" data-testid="landing-businesses">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-xs font-black uppercase tracking-widest text-amber-600 mb-2">4 businesses</div>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight mb-8">Which boss will you be?</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {Object.values(BUSINESSES).map((b, i) => {
          const free = b.id === "dog_walker";
          return (
            <div
              key={b.id}
              className={`relative ${b.lightBg} rounded-3xl p-4 sm:p-5 border-4 ${b.borderColor} card-3d animate-pop-in`}
              style={{ animationDelay: `${i * 100}ms` }}
              data-testid={`landing-biz-${b.id}`}
            >
              <div className={`absolute -top-3 right-3 text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1 ${free ? "bg-emerald-500 text-white" : "bg-slate-900 text-white"}`}>
                {free ? "Free" : <><Lock className="w-3 h-3" /> $8.99 pack</>}
              </div>
              <div className="text-5xl sm:text-6xl mb-2">{b.emoji}</div>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900">{b.name}</h3>
              <p className="text-xs sm:text-sm text-slate-600 font-medium mt-1">{b.tagline}</p>
              <div className={`mt-3 text-xs font-heading font-black ${b.textColor}`}>💵 ${b.priceRange[0]}–${b.priceRange[1]} per job</div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default BusinessShowcase;
